import React from 'react';
import Index from './Index';
import DashboardView from '../components/views/DashboardView';
import { modules } from '../config/const';

function DashboardPage() {
  return <Index content={DashboardView} module={modules.Dashboard} />;
}

export default DashboardPage;
